import IAction from '@signageos/actions/dist/IAction';

export const ReadDeviceDebugSettings = 'Device.Debug.PerformReadDebugSettingsFromPropertyStorage';
export interface ReadDeviceDebugSettings extends IAction<typeof ReadDeviceDebugSettings> {
	debugOn: boolean;
}
